<template>
  <div>
    <b-modal v-model="showModalSvg" size="lg" centered body-class="p-0" hide-footer>
      <span slot="modal-title">
        <small>{{ venueMapBlock ? 'Selecciona un sector' : 'Selecciona tus asientos' }} </small>
      </span>
      <div>
        <div class="modal-body p-0">
          <button v-if="!venueMapBlock && svgBlocks.length > 1" @click="toSvgGeneral()" type="button"
            class="btn btn-secondary btn-sm btn-back-svg">
            Ver plano general
          </button>
          <svg-blocks v-if="venueMapBlock" ref="svgBlocks" :svg-html="eventData.venueSvgStructure"
            @on-select-block="onSelectBlock"></svg-blocks>
          <svg-seats v-else ref="svgSeats" v-model="seatsSelect" :svg-html="svgUrl" @on-verify-seat="onSelectSeat"
            @update-seat="updateSeat" @on-box-seats="boxSeats = $event"></svg-seats>
          <div v-if="loading" class="svg-loading">
            <span class="material-icons animation-spin">scatter_plot</span>
            <div class="ml-3">Validando disponibilidad...</div>
          </div>
          <div v-if="seatMultiple" class="multi-types">
            <div class="multi-types__body">
              <div class="p-3">
                <button @click="seatMultiple = null; boxSeats = [];" type="button" class="close px-2">
                  &times;
                </button>
                <h5 class="mb-4">
                  <b>Seleccione el tipo de entrada</b>
                </h5>
                <div>
                  <b>*Recuerda:</b>
                  <div class="mb-2 small">
                    En el ingreso se realizará la verificación del tipo de entrada con su carné
                    respectivo. Si no cuenta con el carné se le negará el ingreso.
                  </div>
                  <div class="mb-2 small">
                    Si no cuenta con el carné respectivo seleccione general.
                  </div>
                </div>
              </div>
              <div class="list-group mb-3 px-2">
                <button v-for="type in seatMultiple" :key="type.id" type="button" @click="onSelectMultiType(type)"
                  class="list-group-item list-group-item-primary">
                  <span class="row">
                    <span class="col-4">
                      {{ type.name }}
                    </span>
                    <span class="col-4">
                      <b>Precio: {{ currency }} </b>
                      <b>{{ type.price }}</b>
                    </span>
                    <span class="col-4 text-right"> Seleccionar </span>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div v-if="boxMultiType && boxSeatsObj.length" class="multi-types">
            <div class="multi-types__body">
              <div class="p-3">
                <button @click="boxSeats = [];boxSeatsObj = [];" type="button" class="close px-2">
                  &times;
                </button>
                <h5 class="mb-0">
                  <b>Seleccione el tipo de entrada</b>
                </h5>
              </div>
              <div class="list-group px-3">
                <div v-for="seat in boxSeatsObj" :key="seat.id" class="list-group-item">
                  <div class="row align-items-center">
                    <div class="col">
                      {{ seat.id }}
                    </div>
                    <div class="col-8">
                      <select v-model="seat.type" class="form-control form-control-sm">
                        <option v-for="i in seat.types" :key="i.id" :value="i">
                          {{ `${i.name} - ${currency} ${i.price.toFixed(2)}` }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-3 text-center">
                <button @click="saveTypesBox()" type="button" class="btn btn-primary">
                  Guardar selección
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="filters-button" v-if="!venueMapBlock && svgBlocks.length > 1">
          <button @click="filterSeats('ANTIGUO')" type="button" class="btn btn-primary mx-2">
            Antiguo
          </button>
          <button @click="filterSeats('JUBILADOS Y CESANTES')" type="button" class="btn btn-primary mx-2">
            Jubilados y cesantes
          </button>
          <button @click="filterSeats('')" type="button" class="btn btn-primary mx-2">
            Todos
          </button>
        </div> -->
        <div class="modal-legend">
          <div class="row align-items-center px-3">
            <div class="col-12">
              <div class="d-flex justify-content-between align-items-center py-3">
                <span class="d-flex align-items-center">
                  <i class="material-icons text-joinnus">lens</i>
                  <small class="ml-1">Libres</small>
                </span>
                <span class="d-flex align-items-center">
                  <i class="material-icons text-danger">lens</i>
                  <small class="ml-1">Seleccionado</small>
                </span>
                <span class="d-flex align-items-center">
                  <i class="material-icons text-muted">lens</i>
                  <small class="ml-1">No disponibles</small>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import api from '../api';

export default {
  data() {
    return {
      loading: false,
      loaded: false,
      showModalSvg: false,
      venueMapBlock: true,
      eventData: {},
      currentHour: {},
      currentType: {},
      seatsSelect: {},
      svgBlock: {},
      svgUrl: null,
      currentSeat: {},
      seatMultiple: null,
      boxSeats: [],
      boxSeatsObj: [],
      //
      seatsFree: [],
      totalSeatsFree: []
    };
  },
  computed: {
    svgBlocks() {
      return JSON.parse(this.eventData.venueBlockStructure);
    },
    typesIds() {
      return this.currentHour.types.map((el) => el.ticketTypeId).join(',');
    },
    currency() {
      return this.eventData.currency === 'PEN' ? 'S/' : '$';
    },
    boxMultiType() {
      return this.eventData.metadata
        ? this.getMetaValue(this.eventData.metadata, 'boxmultitype')
        : '';
    },
    seatsOccupied() {
      return this.$store.state.cart.cartEvents.map((elem) => ({
        value: elem.value,
        ticketTypeId: elem.ticketTypeId
      }));
    }
  },
  methods: {
    init(hour, type, event) {
      this.currentHour = hour;
      this.currentType = type;
      this.eventData = event;
      // this.seatsSelect = {};
      this.venueMapBlock = true;
      this.showModalSvg = true;
      this.getInitData();
    },
    onSelectBlock(data) {
      const self = this;
      const blockObj = this.svgBlocks.find((i) => i.id === data.id);
      this.svgBlock = blockObj;
      this.svgUrl = blockObj.path;
      this.venueMapBlock = false;
      this.loading = true;
      setTimeout(() => {
        self.verifySeats(data);
      }, 500);
    },
    async onSelectSeat(data) {
      const payload = {
        activityId: this.eventData.activityId,
        dateHourId: this.currentHour.dateHourId,
        typesAvailable: this.typesIds,
        seat: data.id
      };
      this.loading = true;
      this.currentSeat = data;
      const res = await api.seatVerifyAndReserved(payload);
      this.loading = false;
      if (res.available) {
        if (res.types.length > 1) {
          if (this.boxMultiType) {
            this.boxSeatsObj = [];
            this.boxSeats.forEach((seatId) => {
              const item = {
                id: seatId,
                type: res.types[0],
                types: res.types
              };
              // if (seatId === data.id) {
              this.boxSeatsObj.push(item);
              // }
            });
          }
          if (!this.boxSeatsObj.length) {
            this.seatMultiple = res.types;
          }
        } else {
          // eslint-disable-next-line
          data.type = res.types[0].id;
          this.setSeatVerify(true, data);
        }
      } else {
        this.setSeatVerify(false, data);
      }
    },
    onSelectMultiType(type) {
      // fix box multiple type
      if (this.boxSeats.length) {
        this.boxSeats.forEach((seatId) => {
          const currentSeat = {
            id: seatId,
            type: type.id
          };
          this.setSeatVerify(true, currentSeat);
        });
        setTimeout(() => {
          this.boxSeats = [];
        }, 100);
      } else {
        this.currentSeat.type = type.id;
        this.setSeatVerify(true, this.currentSeat);
      }
    },
    saveTypesBox() {
      this.boxSeatsObj.forEach((seat) => {
        const currentSeat = {
          id: seat.id,
          type: seat.type.id
        };
        this.setSeatVerify(true, currentSeat);
      });
      setTimeout(() => {
        this.boxSeats = [];
        this.boxSeatsObj = [];
      }, 100);
    },
    setSeatVerify(available, data) {
      this.seatMultiple = '';
      this.$refs.svgSeats.setSeatVerify(available, data);
    },
    updateSeat({ isRemove, type, id }) {
      const arrSeats = Object.values(this.seatsSelect);
      const arrVal = arrSeats.filter((item) => item.type === type).map((i) => i.id);
      const ticketType = this.currentHour.types.find((obj) => obj.ticketTypeId === type);

      if (arrVal.length > ticketType.maxQuantityPerOrder) {
        this.$refs.svgSeats.updateSeat(id);
        // eslint-disable-next-line
        alert('No puedes comprar más entradas de este tipo para esta fecha y horario!');
        return;
      }
      ticketType.value = arrVal.join();
      this.addEventToCart(ticketType, isRemove);
    },
    addEventToCart(ticketType, isRemove) {
      this.$emit('add-cart', ticketType, isRemove);
    },
    // fns
    toSvgGeneral() {
      const self = this;
      this.venueMapBlock = true;
      setTimeout(() => {
        self.$refs.svgBlocks.init();
      }, 200);
    },
    verifySeats() {
      const { currentType, $refs } = this;
      const payload = {
        typesAvailable: this.typesIds,
        venueId: this.eventData.venueId,
        activityId: this.eventData.activityId,
        dateHourId: this.currentHour.dateHourId,
        blockId: this.svgBlock.id
      };
      const payloadBuyed = {
        activityId: this.eventData.activityId,
        dateHourId: this.currentHour.dateHourId
      };
      $refs.svgSeats.init(async () => {
        // free seats
        const seatsFree = await api.getSeatsStringByBlockId(payload);
        console.log('seatsFree', seatsFree);
        this.seatsFree = seatsFree;
        this.totalSeatsFree = seatsFree;

        const arrAll = seatsFree.map((item) => item.seats);
        if (!arrAll.length) {
          this.loading = false;
          this.toSvgGeneral();
          return;
        }
        const arr = arrAll.join().split(',');
        const arrSeats = arr.map((item) => ({ id: item }));
        this.enableSeatsModal(arrSeats);
        // this.$refs.svgSeats.enableSeats(arrSeats);

        // buyed seats
        const seatsBuyed = await api.getSeatsBuyed(payloadBuyed);
        const arrSeatsBuyed = seatsBuyed.map((i) => i.position || 'undefined');
        this.disableSeatsModal(arrSeatsBuyed);
        // this.$refs.svgSeats.disableSeats(arrSeatsBuyed);

        // blocked seats
        const payloadBlocked = {
          activityId: this.eventData.activityId,
          dateHourId: this.currentHour.dateHourId,
          adminTheater: 1,
        };
        const allSeatsBlocked = await api.getSeatsBlock(payloadBlocked);
        if (allSeatsBlocked.length > 0) {
          const seatsBlocks = allSeatsBlocked.map((el) => (el.position || 'undefined'));
          this.disableSeatsModal(seatsBlocks);
        }

        // active prev select
        if (currentType.value) {
          // prev select store cart
          let arraySeats = [];
          this.seatsOccupied.forEach((elem) => {
            let value = this.setSplitSeats(elem.value);
            if (value.length > 0) {
              value.forEach((val) => {
                arraySeats.push({ id: val, type: elem.ticketTypeId });
              });
            } else {
              arraySeats.push({ id: elem, type: elem.ticketTypeId });
            }
          });

          // const prevSeats = currentType.value.split(',').map((seat) => ({
          //   id: seat,
          //   type: currentType.ticketTypeId
          // }));

          const prevSeats = arraySeats.map((seat) => ({
            id: seat.id,
            type: seat.type
          }));
          $refs.svgSeats.selectToggleSeats(prevSeats);
        }
        // end init svg
        this.loading = false;
      });
    },
    setSplitSeats(value) {
      return value.toString().split(',');
    },
    async getInitData() {
      const self = this;
      // this.loading = true;
      // const data = await api.getDataEvent(this.currentType.activityId);
      // if (!data) {
      //   this.showModalSvg = false;
      //   console.log('Sin data')
      // }
      // this.eventData = data.eventData;
      // this.loading = false;
      // this.loaded = true;
      if (this.svgBlocks.length > 1) {
        this.venueMapBlock = true;
        setTimeout(() => {
          self.$refs.svgBlocks.init();
        }, 200);
      } else {
        this.onSelectBlock({
          id: this.svgBlocks[0].id,
          type: this.currentType.ticketTypeId
        });
      }
    },
    filterSeats(filter) {
      this.$refs.svgSeats.disableAllSeats();
      // console.log('filterSeats', filter);
      if (!filter) {
        // console.log(`filterSeats - ${filter}:`, this.seatsFree);
        const allSeats = [];
        this.seatsFree.forEach( elem => {
          const name = elem.name.toUpperCase();
          if(!name.includes('ANTIGUO')) allSeats.push(elem)
        })
        const seats = this.formattedSeats(allSeats)
        this.$refs.svgSeats.enableSeats(seats);
      } else{
        const allSeats = [];
        this.seatsFree.forEach( elem => {
          const name = elem.name.toUpperCase();
          if(name.includes(filter)) allSeats.push(elem)
        })
        const seats = this.formattedSeats(allSeats)
        // console.log(`filterSeats - ${filter}:`, seats);
        this.enableSeatsModal(seats)
      }
    },
    enableSeatsModal(values) {
      this.$refs.svgSeats.enableSeats(values);
    },
    disableSeatsModal(values) {
      this.$refs.svgSeats.disableSeats(values);
    },
    formattedSeats(value) {
      const arrAll = value.map((item) => item.seats);
      const arrSeats = arrAll.join().split(',');
      return arrSeats.map((item) => ({ id: item }));
    }
  }
};
</script>

<style lang="scss">
.btn-back-svg {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
}

.svg-loading {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(#fff, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-legend {
  border-top: 1px solid #ddd;
}

.text-joinnus {
  color: #00e5b5;
}

.filters-button {
  margin: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>
